// Import the zustand store instance
import useQuoteStore from "../store/QuoteStore";
import Driver from "../../../shared/models/driverModel";
import Occupation from "../../../shared/models/occupationModel";
import Qualification from "../../../shared/models/qualificaitonModel";
import { formatDateT } from "../../../shared/utils/formatters";
import { calculateRes } from "../../../shared/utils/calculateResidentYears";

const TqAddDriverMapper = {
  get() {
    const drivers = useQuoteStore.getState().quote?.risk?.drivers || [];
    // Filter out the main driver using mainUser flag
    return drivers.filter((driver) => driver && driver.mainUser === false);
  },

  set(data) {
    const { updateField } = useQuoteStore.getState();
    const allDrivers = useQuoteStore.getState().quote?.risk?.drivers || [];
    const AddDriverbatch_Date = `${data.AddDriverbatch_Year?.value}/${data.AddDriverbatch_Month?.value}/01`;
    // Find main driver using mainUser flag
    const mainDriver = allDrivers.find(
      (driver) => driver && driver.mainUser === true
    );
    const existingDrivers = this.get();

    // Create new driver instance with default values from QuoteStore pattern
    const newDriver = new Driver(
      {
        titleId: data.addDriverTitle?.value || null,
        titleDescription: data.addDriverTitle?.label || null,
        genderId: null,
        forename: data.firstName || null,
        initials: null,
        surname: data.lastName || null,
        emailAddress: null,
        telephone: null,
        businessTelephone: null,
        dateOfBirth: formatDateT(data.addDob_Date) || null,
        maritalStatusId: data.martialStatus?.value || "S",
        maritalStatusDescription: data.martialStatus?.label || null,
        licenceNumber: data.addlicense + data.addlicenseUser || "",
        licenceTypeId: null,
        licenceRestrictionsId: null,
        licenceCountryOfIssue: "023",
        relationshipId: data.relation?.value || null,
        relationshipDescription: data.relation?.label || null,
        uberDriverRatingId: data.rating?.value || null,
        uberDriverRatingDescription: data.rating?.label || null,
        ukResidenceYears:
          data.residecy === "Yes"
            ? calculateRes(formatDateT(data.addDob_Date))
            : data.residencyYears,
        residentSinceBirth: data.residecy === "Yes",
        mainUser: false, // Always false for additional drivers
        motoringOrganisationId: "UBCL",
        driverPostcode: null,
        uberDriverId: null,
        insuranceCancelled: false,
        criminalConvictions: false,
        objectId: null,
        objectHistoryId: 1,
      },
      null,
      [
        new Occupation(
          data.occupation?.value || null,
          data.addDriverempStatus?.value || null,
          data.addDriverBusinessOccupation?.value || null,
          false,
          null,
          null,
          0
        ),
        ...(data.parttime === "Yes"
          ? [
              new Occupation(
                data.addDriverpartTimeOcc?.value || null,
                data.addDriverPartTimeEmpStatus?.value || null,
                data.addDriverpartTimeBusinessOcc?.value || null,
                true,
                null,
                null,
                0
              ),
            ]
          : []),
      ],
      [...data.additionalDriverClaims], // claims
      [], // convictions
      [
        new Qualification(
          formatDateT(AddDriverbatch_Date) || null,
          data.addvehicleUse == "17" ? "6I3" : "6I4",
          null,
          null,
          0
        ),
      ], // qualifications
      [], // medical conditions
      data.addvehicleUse || null // vehicleUseId as the last parameter
    );

    let updatedDrivers;
    if (data.index !== null && data.index !== undefined) {
      // Update existing driver
      updatedDrivers = [...existingDrivers];
      updatedDrivers[data.index] = newDriver;
    } else {
      // Add new driver
      updatedDrivers = [...existingDrivers, newDriver];
    }

    // Combine main driver with additional drivers
    const finalDrivers = mainDriver
      ? [mainDriver, ...updatedDrivers]
      : updatedDrivers;
    updateField("risk.drivers", finalDrivers);
  },

  delete(index) {
    const { updateField } = useQuoteStore.getState();
    const allDrivers = useQuoteStore.getState().quote?.risk?.drivers || [];
    const mainDriver = allDrivers.find(
      (driver) => driver && driver.mainUser === true
    );
    const additionalDrivers = allDrivers.filter(
      (driver) => driver && driver.mainUser === false
    );

    // Remove driver at specified index from additional drivers
    const updatedAdditionalDrivers = additionalDrivers.filter(
      (_, i) => i !== index
    );

    // Combine main driver with updated additional drivers
    const finalDrivers = mainDriver
      ? [mainDriver, ...updatedAdditionalDrivers]
      : updatedAdditionalDrivers;
    updateField("risk.drivers", finalDrivers);
  },

  isDriverLimitReached() {
    return this.get().length >= 4; // Maximum 4 additional drivers
  },
};

export default TqAddDriverMapper;
